<template>
    <el-row :gutter="4" class="h100">
        <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']" v-loading="showList && treeLoading">
            <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                 @click="showList = !showList"></div>
            <el-tree class="h100 p_all1 metadataTree" :data="treeData" :props="defaultProps"
                     ref="myTree" node-key="id" highlight-current default-expand-all @node-click="selTreeNode">
                <el-tooltip slot-scope="{ node, data }" effect="dark" :content="node.label" placement="top-start">
                    <div class="omit">
                        <img class="treeIcon" src="@/assets/img/dimensionalityIcon.png" v-if="data.basicType == 0"><img class="treeIcon" src="@/assets/img/atomIcon.png" v-else>
                        <span>{{ node.label }}</span>
                    </div>
                </el-tooltip>
            </el-tree>
        </el-col>
        <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
            <div class="el-table-container">
                <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                         @keyup.enter.native="refreshList(1)">
                    <el-form-item prop="keyword" label="关键字查询：">
                        <el-input v-model.trim="searchForm.keyword" maxlength="50" placeholder="请输入元数据名称、值域"
                                  clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="basicAssemblyId" label="组件类型：">
                        <el-select v-model="searchForm.basicAssemblyId" filterable placeholder="请选择组件类型" clearable>
                            <el-option
                                    :key="item.id"
                                    :label="item.assemblyName"
                                    :value="item.id"
                                    v-for="item in basicAssemblyOpt">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="isEmpty" label="值域数据：">
                        <el-select v-model="searchForm.isEmpty" filterable placeholder="请选择值域数据" clearable>
                            <el-option label="值域为空" value="0"></el-option>
                            <el-option label="值域不为空" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">
                            查询
                        </el-button>
                        <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        :data="dataList"
                        v-loading="loading"
                        size="small" height="100%"
                        class="table" border>
                    <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="basicName" label="元数据名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="basicParentName" label="父级元数据名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="basicEnable" label="是否显示">
                        <template slot-scope="scope">
                            {{$dictUtils.getDictLabel("public_state", scope.row.basicEnable ,'')}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="basicType" label="类型" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{$dictUtils.getDictLabel("basic_type", scope.row.basicType ,'')}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="metadataBasicAssemblyName" label="组件类型" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="ranges" label="值域" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="hasPermission('metadata:rangeList:set')" type="text" size="small"
                                       @click="setRange(scope.row.id)">设置
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                            @pagination="refreshList"/>
            </div>
        </el-col>
        <FangeForm ref="rangeForm" @refreshDataList="refreshList"></FangeForm>
    </el-row>
</template>

<script>
    import FangeForm from './rangeForm'
    export default {
        components: {FangeForm},
        data() {
            return {
                showList: true,
                treeData: [],
                treeLoading: false,
                defaultProps: {
                    children: 'children',
                    label: 'basicName'
                },
                searchForm: {
                    basicId: '',
                    basicAssemblyId: '',
                    isEmpty: '',
                    keyword: '',
                    current: 1,
                    size: 20,
                },
                basicAssemblyOpt: [],
                dataList: [],
                total: 0,
                dataListSelections: [],
                loading: false,
            }
        },
        mounted() {
            this.getBasicAssembly()
            this.searchTree()
            this.refreshList(1)
        },
        methods: {
            // 获取数据列表
            refreshList(type) {
                if(type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                this.$axios(this.api.metadata.selectMetadataBasicByAssembly, this.searchForm, 'post').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    } else {
                        this.$message.error('查询失败');
                    }
                })
            },
            // 查询树状数据
            searchTree() {
                this.treeLoading = true
                this.$axios(this.api.metadata.selectBasicRangTree).then(res => {
                    if (res.status) {
                        this.treeData = res.data
                        this.treeData.unshift({
                            basicName: '全部',
                            id: '',
                            children: []
                        })
                        this.$nextTick(() => {
                            this.$refs.myTree.setCurrentKey(this.treeData[0].id);
                        });
                    }
                    this.treeLoading = false
                })
            },
            // 获取组件类型
            getBasicAssembly() {
                this.$axios(this.api.metadata.selectAllMetadataBasicAssembly).then(res => {
                    if (res.status) {
                        this.basicAssemblyOpt = res.data.filter(v=> {return v.id == '4' || v.id == '5' || v.id == '6' || v.id == '7'})
                    }
                })
            },
            // 选择树节点
            selTreeNode(val) {
                this.searchForm.basicId = val.id
                this.refreshList(1)
            },
            // 设置值域
            setRange(id) {
                this.$refs.rangeForm.init(id)
            },
            // 重置
            reset() {
                this.$refs.searchForm.resetFields();
                this.refreshList(1)
            }
        }
    }
</script>

<style scoped>

</style>
